import { Controller } from "@hotwired/stimulus"

// The widget gallery slideover: open/close with transitions, client-side search combined
// with a category filter, and live "already added" badge updates after each successful
// add (the panel stays open so several widgets can be added).
export default class extends Controller {
  static targets = [
    "overlay",
    "backdrop",
    "panel",
    "search",
    "row",
    "category",
    "badge",
    "badgeCount",
    "noResults",
    "categoryChip",
  ]

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    this.boundSubmitEnd = this.handleSubmitEnd.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    this.element.addEventListener("turbo:submit-end", this.boundSubmitEnd)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    this.element.removeEventListener("turbo:submit-end", this.boundSubmitEnd)
  }

  open(event) {
    this.opener = event?.currentTarget
    this.overlayTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.panelTarget.classList.remove("translate-x-full")
    })
    this.searchTarget.focus()
  }

  close() {
    if (this.overlayTarget.classList.contains("hidden")) return

    this.backdropTarget.classList.add("opacity-0")
    this.panelTarget.classList.add("translate-x-full")
    setTimeout(() => this.overlayTarget.classList.add("hidden"), 300)
    if (this.opener) this.opener.focus()
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  selectCategory(event) {
    this.activeCategory = event.currentTarget.dataset.category
    this.categoryChipTargets.forEach((chip) => {
      chip.setAttribute("aria-pressed", String(chip.dataset.category === this.activeCategory))
    })
    this.filter()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    const category = this.activeCategory || "all"
    let anyVisible = false

    this.rowTargets.forEach((row) => {
      const visible =
        row.dataset.searchText.includes(query) &&
        (category === "all" || row.dataset.category === category)
      row.closest("form").classList.toggle("hidden", !visible)
      if (visible) anyVisible = true
    })

    this.categoryTargets.forEach((category) => {
      const hasVisibleRow = category.querySelector("form:not(.hidden)") !== null
      category.classList.toggle("hidden", !hasVisibleRow)
    })

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("hidden", anyVisible)
    }
  }

  handleSubmitEnd(event) {
    if (!event.detail.success) return

    const row = event.target.querySelector('[data-dashboard-add-panel-target="row"]')
    if (!row) return

    const badge = row.querySelector('[data-dashboard-add-panel-target="badge"]')
    const count = row.querySelector('[data-dashboard-add-panel-target="badgeCount"]')
    if (!badge || !count) return

    count.textContent = parseInt(count.textContent || "0", 10) + 1
    badge.classList.remove("hidden")
  }
}
